<template>
	<!-- 新建商品组弹框 -->
	<span>
		<!-- 选择货盘联系人和新建货盘联系人弹框 -->
		<el-dialog width="520px" :title="dialogName" :visible.sync="dialogChooseVisible" @close="resetForms('contactFrom')">
			<el-form :model="formData" ref="contactFrom" :rules="contactRules">
				<div v-if="!isAddContact">
					<el-form-item label="选择货盘联系人" label-width="130px" prop="contact_id">
						<el-select v-model="formData.contact_id" placeholder="请选择" @change="selectRole" style="width: 360px">
							<el-option v-for="(item, index) in contactList" :key="index" :label="item.contact_name" :value="index">
								<span style="float: left">{{ item.contact_name }}</span>
								<span style="float: right">{{ item.contact_mobile }}</span>
							</el-option>
						</el-select>
					</el-form-item>
				</div>
				<div v-if="isAddContact">
					<el-form-item label="联系人姓名" :label-width="formLabelWidth" prop="contact_name">
						<el-input v-model="formData.contact_name" autocomplete="off" placeholder="请填写货盘联系人姓名"></el-input>
					</el-form-item>
					<el-form-item label="手机号" :label-width="formLabelWidth" prop="contact_mobile">
						<el-input v-model="formData.contact_mobile" autocomplete="off" placeholder="请填写货盘联系人手机号"></el-input>
					</el-form-item>
					<el-form-item label="微信号" :label-width="formLabelWidth" prop="contact_wechat">
						<el-input v-model="formData.contact_wechat" autocomplete="off" placeholder="请填写货盘联系人微信号"></el-input>
					</el-form-item>
				</div>
				<p class="yx-color-primary add_contact" @click="addContact" v-if="!isAddContact">找不到货盘联系人？建立新的货盘联系人</p>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogChooseVisible = false">取 消</el-button>
				<el-button type="primary" @click="confirm">确 定</el-button>
			</div>
		</el-dialog>
	</span>
</template>
<script>
import UploadFile from '@/components/common/UploadFile';
import { importPallet, addPalletContact, palletContactList, udpContact } from '@/api/shopManage';
import { checkTextLength, validateTel } from '@/utils/validate';
import { mapState } from 'vuex';
import mixin from '@/mixins';
export default {
	name: 'exportDialog',
	mixins: [mixin],
	components: {
		UploadFile,
	},
	computed: {
		// ...mapState(['vuex_roleType']),
	},
	data() {
		return {
			dialogChooseVisible: false,
			formData: {
				contact_id: '',
				contact_name: '',
				contact_mobile: '',
				contact_wechat: '',
			},
			contactObj: {},
			isAddContact: false,
			formLabelWidth: '100px',
			contactRules: {
				contact_id: [{ required: true, message: '选择货盘联系人', trigger: 'blur' }],
				contact_name: [{ required: true, validator: checkTextLength, trigger: 'blur' }],
				contact_mobile: [{ required: true, validator: validateTel, trigger: 'blur' }],
				contact_wechat: [{ required: true, message: '请输入微信号', trigger: 'blur' }],
			},
			dialogName: '选择货盘联系人',
			contactList: [],
			pallet_id: '',
		};
	},
	methods: {
		//上传货盘
		show({ id }) {
			this.pallet_id = id;
			this.dialogName = '选择货盘联系人';
			this.contactObj = {};
			this.dialogChooseVisible = true;
			this.isAddContact = false;
			this.getContactList();
		},
		async getContactList() {
			const data = await palletContactList();
			this.contactList = data;
		},
		//确认修改
		async confirm() {
			const { isAddContact, pallet_id, contactObj } = this;
			if (isAddContact) {
				this.$refs['contactFrom'].validate(async valid => {
					if (valid) {
						const { code } = await addPalletContact(this.formData);
						if (code !== 0) return;
						this.$message.success('新建成功');
						this.isAddContact = false;
						this.dialogName = '选择货盘联系人';
						this.getContactList();
					}
				});
			} else {
				const { code } = await udpContact({ contact_id: contactObj.contact_id, pallet_id });
				if (code !== 0) return;
				this.dialogChooseVisible = false;
				this.$message.success('修改成功');
				this.$emit('refreshList');
			}
		},
		//新建联系人
		addContact() {
			this.isAddContact = true;
			this.dialogName = '新建货盘联系人';
			this.resetFormData();
			this.resetForms('contactFrom');
		},
		//选择联系人
		selectRole(e) {
			this.contactObj = this.contactList[e];
		},
		//重置弹框表单
		resetForms(from) {
			this.$refs[from].resetFields();
		},
		// 重置表单数据
		resetFormData() {
			this.contactObj = {};
			this.formData = {
				contact_name: '',
				contact_mobile: '',
				contact_wechat: '',
			};
		},
	},
};
</script>
<style lang="less" scoped>
.import-content {
	width: 100%;
	padding: 30px 0;
	background: #f8f8f8;
	box-sizing: border-box;
	.title {
		font-size: 14px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: #323233;
	}
	.desc {
		font-size: 12px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #969799;
		line-height: 18px;
	}
}
.add_contact {
	cursor: pointer;
	margin-left: 130px;
}
.pallut-contact-box {
	margin-top: 34px;
}
</style>
